<template>
  <v-menu
    v-model="tagMenu"
    :close-on-content-click="false"
    offset-y
    transition="slide-y-transition"
    bottom
    content-class="rounded-lg elevation-4"
    :disabled="loading"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        class="mx-2 cursor-pointer font-weight-medium"
        :color="tagData.color"
        :class="tagData.textColor"
        outlined
        small
        v-bind="attrs"
        v-on="on"
        :loading="loading"
        :close="!!info.user.tag" 
        @click:close="updateTag(null)"
      >
        <v-icon right small class="ml-1">{{ tagData.icon }}</v-icon>
        {{ tagData.text }}
      </v-chip>
    </template>

    <v-list min-width="210" dense class="py-2">
      <v-list-item @click="updateTag('پاسخ نداده')" class="mx-1 rounded">
        <v-icon small class="ml-2 error--text">mdi-phone-missed</v-icon>
        <v-list-item-content>
          <v-list-item-title class="error--text font-weight-medium">پاسخ نداده</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="updateTag('نیاز نداشته')" class="mx-1 rounded">
        <v-icon small class="ml-2 warning--text">mdi-minus-circle-outline</v-icon>
        <v-list-item-content>
          <v-list-item-title class="warning--text font-weight-medium">نیاز نداشته</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="updateTag('پرسنل')" class="mx-1 rounded">
        <v-icon small class="ml-2 blue--text">mdi-account-circle-outline</v-icon>
        <v-list-item-content>
          <v-list-item-title class="blue--text font-weight-medium">پرسنل</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="my-1 mx-2"></v-divider>

      <v-list-item @click="updateTag('مارکت‌پلیس (دیجی‌کالا)')" class="mx-1 rounded">
        <v-icon small class="ml-2 red--text text--darken-1">mdi-shopping</v-icon>
        <v-list-item-content>
          <v-list-item-title class="red--text text--darken-1 font-weight-medium">مارکت‌پلیس (دیجی‌کالا)</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="updateTag('مارکت‌پلیس (باسلام)')" class="mx-1 rounded">
        <v-icon small class="ml-2 amber--text text--darken-3">mdi-storefront</v-icon>
        <v-list-item-content>
          <v-list-item-title class="amber--text text--darken-3 font-weight-medium">مارکت‌پلیس (باسلام)</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="updateTag('مارکت‌پلیس (ترب)')" class="mx-1 rounded">
        <v-icon small class="ml-2 red--text text--darken-3">mdi-tag-multiple-outline</v-icon>
        <v-list-item-content>
          <v-list-item-title class="red--text text--darken-3 font-weight-medium">مارکت‌پلیس (ترب)</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="updateTag('مارکت‌پلیس (اسنپ‌شاپ)')" class="mx-1 rounded">
        <v-icon small class="ml-2 purple--text text--darken-1">mdi-basket-outline</v-icon>
        <v-list-item-content>
          <v-list-item-title class="purple--text text--darken-1 font-weight-medium">مارکت‌پلیس (اسنپ‌شاپ)</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="my-1 mx-2" v-if="!showCustomTagInput"></v-divider>

      <v-list-item v-if="!showCustomTagInput" @click="showCustomTagInput = true" class="mx-1 rounded">
        <v-icon small class="ml-2 primary--text">mdi-plus</v-icon>
        <v-list-item-content>
          <v-list-item-title class="primary--text font-weight-medium">افزودن دستی</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-else class="px-2">
        <v-text-field
          v-model="customTagText"
          append-icon="mdi-check"
          dense
          hide-details
          outlined
          placeholder="عنوان تگ..."
          autofocus
          @click:append="updateTag(customTagText)"
          @keydown.enter="updateTag(customTagText)"
        ></v-text-field>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "QrTag",
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    tagMenu: false,
    showCustomTagInput: false,
    customTagText: "",
    loading: false,
  }),
  computed: {
    tagData() {
      const tag = this.info.user?.tag;

      if (!tag) {
        return { 
          text: "بدون تگ (افزودن)", 
          color: "grey", 
          textColor: "grey--text",
          icon: "mdi-tag-outline" 
        };
      }
      if (tag === "پاسخ نداده") {
        return { 
          text: tag, 
          color: "error", 
          textColor: "error--text",
          icon: "mdi-phone-missed" 
        };
      }
      if (tag === "نیاز نداشته") {
        return { 
          text: tag, 
          color: "warning", 
          textColor: "warning--text",
          icon: "mdi-minus-circle-outline" 
        };
      }
      if (tag === "پرسنل") {
        return { 
          text: tag, 
          color: "blue", 
          textColor: "blue--text",
          icon: "mdi-account-circle-outline" 
        };
      }
      if (tag === "مارکت‌پلیس (دیجی‌کالا)") {
        return { 
          text: tag, 
          color: "red darken-1", 
          textColor: "red--text text--darken-1",
          icon: "mdi-shopping" 
        };
      }
      if (tag === "مارکت‌پلیس (باسلام)") {
        return { 
          text: tag, 
          color: "amber darken-3", 
          textColor: "amber--text text--darken-3",
          icon: "mdi-storefront" 
        };
      }
      if (tag === "مارکت‌پلیس (ترب)") {
        return { 
          text: tag, 
          color: "red darken-3", 
          textColor: "red--text text--darken-3",
          icon: "mdi-tag-multiple-outline" 
        };
      }
      if (tag === "مارکت‌پلیس (اسنپ‌شاپ)") {
        return { 
          text: tag, 
          color: "purple darken-1", 
          textColor: "purple--text text--darken-1",
          icon: "mdi-basket-outline" 
        };
      }
      return { 
        text: tag, 
        color: "success", 
        textColor: "success--text",
        icon: "mdi-check-circle-outline" 
      };
    },
  },
  watch: {
    tagMenu(val) {
      if (!val) {
        setTimeout(() => {
          this.showCustomTagInput = false;
          this.customTagText = "";
        }, 300);
      }
    },
  },
  methods: {
    updateTag(newTag) {
      if (newTag !== null && (!newTag || newTag.trim() === "")) return;

      this.loading = true;
      this.tagMenu = false;

      const finalTag = newTag ? newTag.trim() : null;

      const payload = {
        user_id: this.info?.user?.id || "",
        tag: finalTag,
      };
      
      this.$instanceAxios
        .post(`${this.$coreApi2}/admin/user/updateTag`, payload)
        .then(() => {
          this.$set(this.info.user, "tag", finalTag);
          this.$toast.success(finalTag === null ? "تگ با موفقیت حذف شد." : "تگ با موفقیت ثبت شد.");
          this.$emit("updated");
        })
        .catch(() => {
          this.$toast.error(finalTag === null ? "خطا در حذف تگ!" : "خطا در ثبت تگ!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
